<template>
    <div class="packages">
        <div class="packages-box packages-box--free">
            <h4>{{ $t("other_woutlog.p_packages_text_33") }}</h4>
            <div class="box-price">
                <div class="price-value">
                    {{ $t("other_woutlog.p_packages_text_34") }}<br />
                    {{ $t("other_woutlog.p_packages_text_35") }}<br />
                    {{ $t("other_woutlog.p_packages_text_36") }}
                </div>
            </div>

            <div class="balloon balloon-01"></div>
            <div class="balloon balloon-02"></div>
            <div class="balloon balloon-03"></div>

            <!-- <div class="box-properties">
                <ul class="pl-0">
                    <li>
                        <i class="icon--check"></i>
                        3 aktívne ponuky
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        Maximálne 5 klientov
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        2 farebné kombinácie
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez možnosti pod účtov
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez možnosti recenzií v ponuke
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez možnosti skrytia logo DOFFERO
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez možnosti vlastnej šablóny
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez jazykových mutácií
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez obrázkov v položkách
                    </li>
                    <li>
                        <svg class="icon--times" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3 0.709995C13.2075 0.617291 13.0976 0.543744 12.9766 0.493562C12.8556 0.443381 12.7259 0.417551 12.595 0.417551C12.464 0.417551 12.3343 0.443381 12.2134 0.493562C12.0924 0.543744 11.9825 0.617291 11.89 0.709995L6.99998 5.58999L2.10998 0.699995C2.0174 0.607413 1.90749 0.533973 1.78652 0.483868C1.66556 0.433763 1.53591 0.407974 1.40498 0.407974C1.27405 0.407974 1.1444 0.433763 1.02344 0.483868C0.902472 0.533973 0.792561 0.607413 0.699979 0.699995C0.607397 0.792576 0.533957 0.902487 0.483852 1.02345C0.433747 1.14442 0.407959 1.27406 0.407959 1.40499C0.407959 1.53593 0.433747 1.66557 0.483852 1.78654C0.533957 1.9075 0.607397 2.01741 0.699979 2.10999L5.58998 6.99999L0.699979 11.89C0.607397 11.9826 0.533957 12.0925 0.483852 12.2135C0.433747 12.3344 0.407959 12.4641 0.407959 12.595C0.407959 12.7259 0.433747 12.8556 0.483852 12.9765C0.533957 13.0975 0.607397 13.2074 0.699979 13.3C0.792561 13.3926 0.902472 13.466 1.02344 13.5161C1.1444 13.5662 1.27405 13.592 1.40498 13.592C1.53591 13.592 1.66556 13.5662 1.78652 13.5161C1.90749 13.466 2.0174 13.3926 2.10998 13.3L6.99998 8.40999L11.89 13.3C11.9826 13.3926 12.0925 13.466 12.2134 13.5161C12.3344 13.5662 12.464 13.592 12.595 13.592C12.7259 13.592 12.8556 13.5662 12.9765 13.5161C13.0975 13.466 13.2074 13.3926 13.3 13.3C13.3926 13.2074 13.466 13.0975 13.5161 12.9765C13.5662 12.8556 13.592 12.7259 13.592 12.595C13.592 12.4641 13.5662 12.3344 13.5161 12.2135C13.466 12.0925 13.3926 11.9826 13.3 11.89L8.40998 6.99999L13.3 2.10999C13.68 1.72999 13.68 1.08999 13.3 0.709995Z" fill="#F3385A"/>
                        </svg>
                        Bez dokumentov v položkách
                    </li>
                </ul>
            </div> -->
            <!-- <div v-if="premium.id || !isadmin" class="package-btn">
                <a @click="pathFree" class="btn--outline">
                    Chcem FREE verziu
                </a>
            </div> -->
            <!-- <div v-if="!premium.id && isadmin" class="btn--actual"  style="color: #F93C34;">
                <a>
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Tvoj aktuálny balík
                </a>
            </div> -->
        </div>
        <div class="packages-box packages-box--main">
            <!--div class="cs-badge">UVÁDZACIA CENA do 31.12.2021</div-->

            <!-- <div v-if="!pretlak" class="box-price">
                <div class="price-value">4,30 € <span>/ mesačne</span></div>
                <div class="price-helper">*platí sa na ročnej báze 51,60 €</div>
            </div>
            <div v-if="pretlak" class="box-price">
                <div class="price-value">3,65 € <span>/ mesačne</span></div>
                <div class="price-helper"><span class="pretlak_cena">4,30 € <span></span></span> *platí sa na ročnej báze 43,90 €</div>
            </div> -->
            <h4>{{ $t("other_woutlog.p_packages_text_1") }}</h4>
            <div class="price-value">
                {{ $t("other_woutlog.p_packages_text_2") }}
            </div>
            <div class="box-properties">
                <ul class="pl-0">
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_3") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_4") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_5") }}
                        <span
                            class="has-tooltip"
                            data-balloon-length="large"
                            :aria-label="$t('other_woutlog.p_packages_text_6')"
                            data-balloon-pos="down"
                        >
                            {{ $t("other_woutlog.p_packages_text_7") }}
                        </span>
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        <span
                            class="has-tooltip"
                            data-balloon-length="large"
                            :aria-label="$t('other_woutlog.p_packages_text_8')"
                            data-balloon-pos="down"
                        >
                            {{ $t("other_woutlog.p_packages_text_9") }}
                        </span>
                        {{ $t("other_woutlog.p_packages_text_10") }}
                    </li>

                    <li>
                        <i class="icon--check"></i>
                        <span
                            class="has-tooltip"
                            data-balloon-length="large"
                            :aria-label="$t('other_woutlog.p_packages_text_11')"
                            data-balloon-pos="down"
                        >
                            {{ $t("other_woutlog.p_packages_text_12") }}
                        </span>
                        {{ $t("other_woutlog.p_packages_text_13") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_14") }}
                        <span
                            class="has-tooltip"
                            data-balloon-length="large"
                            :aria-label="$t('other_woutlog.p_packages_text_15')"
                            data-balloon-pos="down"
                        >
                            {{ $t("other_woutlog.p_packages_text_16") }}
                        </span>
                        {{ $t("other_woutlog.p_packages_text_17") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        <span
                            class="has-tooltip"
                            data-balloon-length="large"
                            :aria-label="$t('other_woutlog.p_packages_text_18')"
                            data-balloon-pos="down"
                        >
                            {{ $t("other_woutlog.p_packages_text_19") }}
                        </span>
                        {{ $t("other_woutlog.p_packages_text_20") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_21") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_22") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_23") }}
                        <span
                            class="has-tooltip"
                            data-balloon-length="large"
                            :aria-label="$t('other_woutlog.p_packages_text_24')"
                            data-balloon-pos="down"
                        >
                            {{ $t("other_woutlog.p_packages_text_25") }}
                        </span>
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_26") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_27") }}
                    </li>
                    <li>
                        <i class="icon--check"></i>
                        {{ $t("other_woutlog.p_packages_text_28") }}
                        <a href="https://www.superfaktura.sk/" target="_blank">
                            {{ $t("other_woutlog.p_packages_text_29") }}
                        </a>
                    </li>
                </ul>
            </div>
            <div v-if="!premium.id" class="package-btn">
                <a @click="pathPremium" class="btn--primary">
                    {{ $t("other_woutlog.p_packages_text_30") }}
                </a>
            </div>
            <div v-if="premium.id" class="btn--actual" style="color: #fff">
                <a>
                    <svg
                        width="26"
                        height="27"
                        viewBox="0 0 26 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            y="0.5"
                            width="26"
                            height="26"
                            rx="13"
                            fill="#34D399"
                        />
                        <path
                            d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    {{ $t("other_woutlog.p_packages_text_31") }}
                </a>
            </div>
            <p class="package-extrainfo">
                {{ $t("other_woutlog.p_packages_text_32") }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["animations", "isadmin", "pretlak"],
    data() {
        return {
            premium: {},
        };
    },
    created() {
        if (!this.animations) {
            setTimeout(() => {
                $(".packages-box--free").css("opacity", "1");
                $(".packages-box--main").css("opacity", "1");
                $(".packages-box--free").css("transform", "translate(0)");
                $(".packages-box--main").css("transform", "translate(0)");
            }, 100);
        }
        /*axios.get('/api/premium').then(response => {
            this.premium = response.data
        })*/
    },
    methods: {
        pathPremium() {
            // Google DataLayer
            //location.href = "/registracia"
            this.$gtm.push({
                event: "button",
                "Event category": "button",
                "Event action": "click",
                "Event label": "premium",
            });
            if (this.isadmin) {
                this.$emit("next", 1);
            } else {
                location.href = "/registracia";
                localStorage.setItem("premium", "true");
            }
        },
        pathFree() {
            // Google DataLayer
            this.$gtm.push({
                event: "button",
                "Event category": "button",
                "Event action": "click",
                "Event label": "free",
            });
            localStorage.removeItem("premium");
            if (this.isadmin) {
                this.$emit("next", 0);
            } else {
                location.href = "/registracia";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.packages .packages-box--main .btn--actual {
    background: rgba(249, 60, 52, 1);
    a {
        color: #fff;
    }
}
.btn--actual {
    width: 326px;
    height: 55px;
    background: rgba(249, 60, 52, 0.1);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: normal;
    @media (max-width: 992px) {
        width: 100%;
    }
    a {
        svg {
            margin-right: 15px;
        }
        font-family: "Fontfabric", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #f93c34;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        &:hover {
            color: #f93c34;
            cursor: default;
            text-decoration: none;
        }
    }
}
.icon--times {
    position: absolute;
    left: 0;
    top: 9px;
    width: 15px;
    height: 12px;
}
.btn--primary:active,
.btn--primary:focus,
.btn--primary:hover {
    box-shadow: 0 100px 80px rgb(249 60 52 / 7%),
        0 41.7776px 33.4221px rgb(249 60 52 / 5%),
        0 22.3363px 17.869px rgb(249 60 52 / 4%),
        0 12.5216px 10.0172px rgb(249 60 52 / 4%),
        0 6.6501px 5.32008px rgb(249 60 52 / 3%),
        0 2.76726px 2.21381px rgb(249 60 52 / 2%);
    color: #fff !important;
}
.btn--outline {
    border: 2px solid #f93c34;
    background: 0 0;
    color: #f93c34 !important;
    font-weight: 600;
    width: 100%;
    height: 55px;
    &:hover {
        color: #fff !important;
    }
}
.btn--primary {
    background: #f93c34;
    color: #fff !important;
    width: 100%;
    height: 55px;
}
.btn--light,
.btn--outline,
.btn--primary {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    padding: 14px 20px;
    border-radius: 8px;
    text-decoration: none;
}
.packages {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (max-width: 667px) {
    .packages {
        flex-wrap: wrap;
        padding-top: 25px;
        margin: 15px;
    }
}
.packages .packages-box {
    border-radius: 16px;
    max-width: 480px;
    width: 100%;
    margin: 0 10px;
}
.packages .packages-box--free {
    background: #3455db;
    border-radius: 16px;
    padding: 40px 37px 433px 50px;
    position: relative;
    z-index: 10;
    max-width: 480px;
    opacity: 0;
    transform: translate(-10vw, 0);
}

.balloon {
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
}

.balloon-01 {
    background-image: url(/img/balon_red.png);
    bottom: -30px;
    left: 50%;
    margin-left: -142px;
    width: 284px;
    height: 433px;
    z-index: 100;

    animation: floating 2s infinite alternate;
}

.balloon-02 {
    background-image: url(/img/balon_blue_01.png);
    bottom: 20px;
    left: -45px;
    width: 213px;
    height: 303px;

    animation: floating 2s 1.5s infinite alternate;
}

.balloon-03 {
    background-image: url(/img/balon_blue_02.png);
    width: 213px;
    height: 303px;
    bottom: 20px;
    right: -45px;

    animation: floating 3s 0.8s infinite alternate;
}
@media (max-width: 667px) {
    .packages .packages-box--free {
        order: 2;
        padding: 30px 20px 300px 20px;
    }

    .balloon-01 {
        width: 184px;
        height: 333px;
        margin-left: -92px;
    }

    .balloon-02 {
        width: 113px;
        height: 203px;
        left: 0px;
    }

    .balloon-03 {
        width: 113px;
        height: 203px;
        right: 0;
    }
}
.packages .packages-box--free h4 {
    color: #fff9fb;
    font-weight: 800;
    font-size: 14px;
    opacity: 0.45;
    margin-bottom: 10px;
}
@media (max-width: 667px) {
    .packages .packages-box--free h4 {
        font-size: 14px;
    }
}
.packages .packages-box--free .box-price {
    color: #fff;
    font-size: 38px;
    font-weight: 800;
    margin-bottom: 40px;
}
@media (max-width: 667px) {
    .packages .packages-box--free .box-price {
        margin-bottom: 15px;
    }
}
.packages .packages-box--free .box-price .price-helper,
.packages .packages-box--free .box-price span {
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
}
.packages .packages-box--free .box-properties ul {
    margin-bottom: 35px;
}
@media (max-width: 667px) {
    .packages .packages-box--free .box-properties ul {
        margin-bottom: 20px;
    }
}
.packages .packages-box--free .box-properties ul li {
    color: #212541;
    margin-bottom: 4px;
    line-height: 1.85;
    font-size: 18px;
    font-weight: 700;
    padding-left: 30px;
    position: relative;
}
@media (max-width: 667px) {
    .packages .packages-box--free .box-properties ul li {
        font-size: 14px;
    }
}
.packages .packages-box--free .box-properties ul li .icon--check {
    background: url(/img/welcome/icons/check-colored.svg) no-repeat;
    position: absolute;
    left: 0;
    top: 9px;
    width: 15px;
    height: 12px;
}
@media (max-width: 667px) {
    .packages .packages-box--free .box-properties ul li .icon--check {
        top: 5px;
    }
}
.packages .packages-box--free .box-properties ul li .has-tooltip {
    cursor: pointer;
    display: inline-block;
    padding-bottom: 10px;
}
.packages .packages-box--main {
    background: #fff;
    border-radius: 16px;
    padding: 34px 60px 50px;
    box-shadow: 0 100px 80px rgba(0, 0, 0, 0.07),
        0 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
        0 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
        0 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
        0 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
        0 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
    opacity: 0;
    transform: translate(10vw, 0);
    span.pretlak_cena {
        position: relative;
        font-style: normal;
        font-weight: 400;
        font-size: 24px !important;
        line-height: 28px;
        color: rgba(255, 255, 255, 0.8) !important;
        margin-right: 14px;
        span {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            left: 0;
            width: 100%;
            height: 3px;
            background: #f93c34;
            border-radius: 32px;
        }
    }
}
@media (max-width: 992px) {
    .packages .packages-box--main {
        padding: 24px 40px 40px;
    }
}
@media (max-width: 667px) {
    .packages .packages-box--main {
        margin-bottom: 15px;
        padding: 24px 22px;
    }
}
.packages .packages-box--main .cs-badge {
    margin-bottom: 7px;
}
.packages .packages-box--main h4 {
    color: #212541;
    opacity: 0.45;
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 15px;
}
@media (max-width: 667px) {
    .packages .packages-box--main h4 {
        font-size: 14px;
    }
}
.packages .packages-box--main .box-price {
    color: #212541;
    font-size: 44px;
    margin-bottom: 20px;
}
@media (max-width: 667px) {
    .packages .packages-box--main .box-price {
        font-size: 28px;
    }
    .packages .packages-box--main .box-price .price-value {
        margin-bottom: 8px;
    }
}
.packages .packages-box--main .box-price .price-helper,
.packages .packages-box--main .box-price span {
    color: #212541;
    opacity: 0.45;
    font-size: 16px;
}
@media (max-width: 667px) {
    .packages .packages-box--main .box-price .price-helper,
    .packages .packages-box--main .box-price span {
        font-size: 12px;
    }
}
.packages .packages-box--main .box-properties ul {
    margin-bottom: 15px;
}
.packages .packages-box--main .box-properties ul li {
    color: #212541;
    margin-bottom: 4px;
    line-height: 1.85;
    font-size: 18px;
    font-weight: 700;
    padding-left: 30px;
    position: relative;
}
@media (max-width: 667px) {
    .packages .packages-box--main .box-properties ul li {
        font-size: 14px;
    }
}
.packages .packages-box--main .box-properties ul li .icon--check {
    background: url(/img/welcome/icons/check-colored.svg) no-repeat;
    position: absolute;
    left: 0;
    top: 9px;
    width: 15px;
    height: 12px;
}
@media (max-width: 667px) {
    .packages .packages-box--main .box-properties ul li .icon--check {
        top: 6px;
    }
}
.packages .packages-box--main .box-properties ul li .has-tooltip {
    cursor: pointer;
    display: inline-block;
    padding-bottom: 4px;
    line-height: 1;
    border-bottom: 2px dashed #212541;
}
.packages .packages-box--main .package-extrainfo {
    font-size: 14px;
    margin-top: 15px;
    text-align: center;
}
.packages .packages-box--main .price-value {
    position: relative;
    font-size: 52px;
    font-weight: 700;
    padding-bottom: 20px;
}
.packages .packages-box--main .price-value:after {
    content: "";
    height: 4px;
    background: #3455db;
    border-radius: 4px;
    width: 110px;
    display: block;
    position: absolute;
    left: 0;
    bottom: 10px;
}
@media (max-width: 667px) {
    .packages .packages-box--main .package-extrainfo {
        font-size: 10px;
    }

    .packages .packages-box--main .price-value {
        font-size: 36px;
    }
}
.cs-badge {
    background: #f93c34;
    color: #fff;
    padding: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.09em;
    font-weight: 500;
}
.btn--outline:hover {
    background: #f93c34;
    color: #fff;
}
a:active,
a:focus,
a:hover {
    text-decoration: none;
}

@keyframes floating {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(0, 50px);
    }
}
</style>
